/**
 * 検索フォームの変更を検知し検索を行う
 */
$(function () {
    // フォーム外へのチェンジイベントのバブリングを禁止
    $(document).on('change', 'form', function(e) {
        e.stopPropagation();
    });
    // 多重送信防止用フラグ
    let searchProcessFlag = false;
    // 検索フォームの変更時
    $(document).on('change', '#search-form, #toolbar-keyword-search', function() {
        // 検索エリアのエラーメッセージ破棄
        $('#search-form .invalid-feedback').not('.copy').remove();
        // ボタン検索フォームはスルーする
        if ($(this).hasClass('click-search')) {
            return false;
        }
        if (searchProcessFlag || $(this).hasClass('exclude-from-search')) { return;}
        searchProcessFlag = true;
        // コンテンツを読込
        if ($(this).hasClass('show-error-toast')) {
            load_contents(null, false, '#search-form', '#contents', false, true)
        } else {
            load_contents(null, false);
        }
        setTimeout(function() {
            searchProcessFlag = false;
        }, 100);
    });

    // 検索ボタンによる検索フォーム検索ボタン押下
    $(document).on('click', '#click-search-form_search', function() {
        let formSelector = $('#search-form');
        let exclusionParam = [];
        let keywordSearch = $('#toolbar-keyword-search');
        if (formSelector.length) {
            if (keywordSearch.length) {
                // キーワード検索情報を含める
                formSelector.append($('<input></input>', {
                    type: 'hidden',
                    name: keywordSearch.attr('name'),
                    value: keywordSearch.val(),
                }));
            }
            let action = formSelector.attr('action');
            let formData = formSelector.serializeArray();
            let params = formData.filter(function(item) {
                return item.value.length > 0; // 空ではない要素のみ残す
            });
            exclusionParam.push('holding_id', 'company_id', 'section_id', 'page');
            action = _request.create_affiliation_url(action, false, params, exclusionParam);
            location.href = action;
        }
        return false;
    });

    // キーワード検索の実行ボタンクリック時
    $(document).on('click', '#toolbar-keyword-search-submit, #toolbar-keyword-search-reset', function() {
        // コンテンツを読込
        load_contents(null, false);
    });
    // 表示設定の表示時
    $(document).on('click', '[data-display-setting-modal]', function(e) {
        // 設定モーダルを表示
        _modal.create(this, 'display-setting-modal', ['route', 'path'], true);
    });
    // 表示設定の適用時
    $(document).on('click', '[data-display-save-modal]', function(e) {
        _modal.submit(this, 'display-save-modal', null, null, '-form', false, function(){
            _request.set_parameters([{'name' : 'page', 'value' : '1'}]);
        });
    });
    // 表示設定の初期化時
    $(document).on('click', '[data-display-delete-modal]', function(e) {
        _modal.submit(this, 'display-delete-modal', null, null, '-form', false, function(){
            _request.set_parameters([{'name' : 'page', 'value' : '1'}]);
        });
    });
    // 表示設定の適用時
    $(document).on('click', '.sort-column', function(e) {
        let datas = [];
        datas.push({'name' : 'route', 'value' : $(this).data('route')});
        datas.push({'name' : 'order', 'value' : $(this).data('order')});
        datas.push({'name' : 'sort', 'value' : $(this).data('sort')});
        if ($(this).is('[data-is_second_sortable]')) {
            datas.push({'name' : 'is_second_sortable', 'value' : $(this).data('is_second_sortable')});
        }
        _ajax.post($(this).data('action'), datas, function(results) {
            load_contents();
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });
});
